import { useTheme } from '@mui/material/styles';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import TooltipDiv from '../../shared/TooltipDiv';
import { Dictionary } from '../../../model/base';
import { EventValue, KeyValue } from '../../../model/visionaware';
import { useState } from 'react';

export interface ChartProp {
    name: number | string | string[] | Dictionary<EventValue> | KeyValue;
    value: number | string | string[] | Dictionary<EventValue> | KeyValue;
}

interface BarChartProps {
    data?: ChartProp[];
    roi: boolean;
    unit: string;
}

const BarTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <TooltipDiv>{Number(payload[0].value).toLocaleString()} {label}</TooltipDiv>
        );
    }

    return null;
};

function renderTooltip(props: any, label: string, barHover: boolean) {
    return <BarTooltip {...props} label={label} active={barHover} />
}

export default function ComparisonBarChart({ data, roi, unit }: BarChartProps) {
    const theme = useTheme();
    const [barHover, setBarHover] = useState(false);

    return (
        <ResponsiveContainer className="chart-area" width="100%" height="100%" debounce={1}>
            <BarChart
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
                barSize={26}
            >
                <CartesianGrid stroke={theme.palette.shadow.dark} strokeDasharray="3 3" vertical={false} />
                <XAxis
                    dataKey="name"
                    stroke={theme.palette.primary.main}
                    tickLine={false}
                    axisLine={false}
                    strokeDasharray="3 3"
                    style={{
                        fontSize: '0.8rem',
                        fontFamily: 'Montserrat',
                        fontWeight: 600
                    }}
                />
                <YAxis
                    stroke={theme.palette.text.primary}
                    tickLine={false}
                    axisLine={false}
                    style={{
                        fontSize: '0.8rem',
                        fontFamily: 'Montserrat',
                        fontWeight: 600
                    }}
                    tickFormatter={(value) => roi ? '$' + value : value}
                />


                <Bar dataKey="value" barSize={100}
                    onMouseEnter={
                        bar => {
                            console.log(bar);
                        }
                    }
                >
                    {data && data.map((entry, index) => (
                        <Cell fill={index % 2 === 0 ? theme.palette.success.main : theme.palette.error.main} key={`cell-${index}`} onMouseEnter={() => {
                            setBarHover(true)
                        }}
                            onMouseOut={
                                () => setBarHover(false)
                            }
                        />
                    ))}
                </Bar>
                <Tooltip content={(e) => renderTooltip(e, unit, barHover)} cursor={false} />

            </BarChart>
        </ResponsiveContainer>
    )
}